import { ref } from 'vue'

const isPlayMap = ref(new Map<string, boolean>())
export const useChatMessageIsPlayMap = (key: string) => {
  isPlayMap.value.set(key, false)
  const _setIsPlayMap = (value: boolean) => {
    isPlayMap.value.set(key, value)
  }
  const _toggleIsPlayMap = () => {
    const isPlay = isPlayMap.value.get(key)
    if (isPlay) {
      for (const k of isPlayMap.value.keys()) {
        if (k !== key) {
          isPlayMap.value.set(k, false)
        }
      }
    }
  }

  const disable = () => {
    _setIsPlayMap(false)
  }

  const enable = () => {
    _setIsPlayMap(true)
    _toggleIsPlayMap()
  }

  return {
    disable,
    enable,
    isPlayMap,
  }
}

const extraPausers = new Set<() => void>()

export const onPauseAllChatMessagePlayers = (pause: () => void) => {
  extraPausers.add(pause)

  return () => {
    extraPausers.delete(pause)
  }
}

export const pauseAllChatMessagePlayers = () => {
  for (const key of isPlayMap.value.keys()) {
    isPlayMap.value.set(key, false)
  }
  extraPausers.forEach((pause) => pause())
}
